import { render, staticRenderFns } from "./EmailMessagesTab.vue?vue&type=template&id=708b5a59"
import script from "./EmailMessagesTab.vue?vue&type=script&lang=js"
export * from "./EmailMessagesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports